/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerCreateMutationRequest, InvitationsControllerCreateMutationResponse, InvitationsControllerCreate400, InvitationsControllerCreate401, InvitationsControllerCreate403, InvitationsControllerCreate409 } from "../../models/invitationsController/InvitationsControllerCreate";

function getInvitationsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/invitations` as const }  
  return res
}

/**
 * @description Creates a new invitation for a user to join a specific scope (organization, team, or project). Multiple invitations can be created for the same email address to different scopes, but only one pending invitation per email per scope is allowed. Trimble IAM sends the invitation email; the invitee accepts it by signing in with Trimble ID. If the user is already a member of the organization's Trimble account, access is granted and they are notified.
 * @summary Create a new invitation
 * {@link /api/v1/invitations}
 */
export async function invitationsControllerCreate(data?: InvitationsControllerCreateMutationRequest, config: Partial<RequestConfig<InvitationsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<InvitationsControllerCreateMutationResponse, ResponseErrorConfig<InvitationsControllerCreate400 | InvitationsControllerCreate401 | InvitationsControllerCreate403 | InvitationsControllerCreate409>, InvitationsControllerCreateMutationRequest>({ method : "POST", url : getInvitationsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}